import './Frontload.scss';

import { useFormikContext } from 'formik';
import React from 'react';

import EditablePercentInput from '../../../../../../../../../common/EditableTableCells/EditablePercentInput';
import bem from '../../../../../../../../../utils/bem';
import type { MultipleEditDrawerLineItemsFormValues } from '../../../../../types';

const [block, element] = bem('frontload-multi-edit-section');

export default function Frontload(): JSX.Element {
  const {
    values: { buffer },
    setFieldValue,
  } = useFormikContext<MultipleEditDrawerLineItemsFormValues>();

  const onChangeFrontLoad = (frontLoadValue: number): void => {
    setFieldValue('buffer.frontLoadPercent', frontLoadValue);
  };

  return (
    <div className={block()}>
      <div className={element('title')}>Override existing frontload values on selected line items.</div>
      <div className={element('container')}>
        <div className={element('wrapper-percent-input')}>
          <EditablePercentInput
            labelText="FrontLoad"
            initialValue={buffer.frontLoadPercent}
            onSubmit={onChangeFrontLoad}
            variant={'base'}
            lowerLimit={0}
            upperLimit={400}
            withBorder
          />
          <span>%</span>
        </div>
      </div>
    </div>
  );
}
